import logoImg from "./logo.png";
import discordLogoBtnImg from "./images-discord-button.svg";
import lightningImg from "./lightning.svg";
import nft_1Img from "./nft_1.jfif";
import nft_2Img from "./nft_2.jfif";
import nft_3Img from "./nft_3.jpg";
import nft_4Img from "./nft_4.jfif";
import nearProtocolImg from "./near-protocol-logo.svg";

export const logo = logoImg;
export const discordLogoBtn = discordLogoBtnImg;
export const lightning = lightningImg;
export const nft_1 = nft_1Img;
export const nft_2 = nft_2Img;
export const nft_3 = nft_3Img;
export const nft_4 = nft_4Img;
export const nearProtocal = nearProtocolImg;

